import { IconMessageQuestion } from '@calendly/ui/components/glyphs/IconMessageQuestion'

import { PANELS } from 'constants/event_type_editor_panels'

export const BOOKING_PAGE_TAB_KEY = 'booking-page'

export const bookingPageTabDefinition = {
  key: BOOKING_PAGE_TAB_KEY,
  label: 'Questions',
  icon: IconMessageQuestion,
  subtitle: 'Questions, page options',
  formKey: 'moreOptions',
  panelKeys: [
    PANELS.bookingPageOptions,
    PANELS.inviteeForm,
  ],
  usesCustomPanel: true,
}
